import Vue from 'vue'

import ExposureBox from './ExposureBox.vue'
import CustomSelect from './CustomSelect.vue'
import AdaptiveImage from './AdaptiveImage.vue'
import CustomTooltip from './CustomTooltip.vue'
import PicturePreview from './PicturePreview.vue'
import TipButton from './TipButton.vue'
import RequestResult from './RequestResult.vue'
import CommonLogo from './CommonLogo.vue'
import FooterTip from './FooterTip.vue'
import InnerTitle from './InnerTitle.vue'
import TextUnfold from './TextUnfold.vue'
import GuidePage from './GuidePage.vue'
import SkeletonScreen from './SkeletonScreen.vue'

Vue.component('ExposureBox', ExposureBox)
Vue.component('CustomSelect', CustomSelect)
Vue.component('AdaptiveImage', AdaptiveImage)
Vue.component('CustomTooltip', CustomTooltip)
Vue.component('PicturePreview', PicturePreview)
Vue.component('TipButton', TipButton)
Vue.component('RequestResult', RequestResult)
Vue.component('CommonLogo', CommonLogo)
Vue.component('FooterTip', FooterTip)
Vue.component('InnerTitle', InnerTitle)
Vue.component('TextUnfold', TextUnfold)
Vue.component('GuidePage', GuidePage)
Vue.component('SkeletonScreen', SkeletonScreen)

import ImagePreview from './PicturePreviewVue'

export function ImagePreviewUtil({ ...rest }) {
    return ImagePreview({
        ...rest
    })
}

export default function PicturePreviewVue(data) {
    let _data = data
    if (Object.prototype.toString.call(data) === '[object String]') {
        // ^ 仅传入一个地址
        _data = {
            urlList: [_data],
            initialIndex: 0,
            ...data
        }
    } else if (Object.prototype.toString.call(data) === '[object Object]') {
        const index = data.urlList.indexOf(data.url)
        _data = {
            urlList: data.urlList,
            initialIndex: index,
            ...data
        }
    }
    ImagePreviewUtil(_data)
}
